import { mapGetters } from 'vuex';
import { changeSkin } from '@/utils/common.js';
import { personalCenterMenu } from '@/utils/default-data.js';
import Service from '@/service/index.js';
import SigninDialog from '@/views/signin/signin-dialog/signin-dialog.vue';
import AreaCodeHolder from '@/common/areaCodeHolder.js';
export default {
  components: {
    SigninDialog
  },
  data () {
    return {
      logoMap: {
        4510: require('@/assets/logo/4510.png'),
        451002: require('@/assets/logo/451002.png'),
        451003: require('@/assets/logo/451003.png'),
        451022: require('@/assets/logo/451022.png'),
        451024: require('@/assets/logo/451024.png'),
        451026: require('@/assets/logo/451026.png'),
        451027: require('@/assets/logo/451027.png'),
        451028: require('@/assets/logo/451028.png'),
        451029: require('@/assets/logo/451029.png'),
        451030: require('@/assets/logo/451030.png'),
        451031: require('@/assets/logo/451031.png'),
        451081: require('@/assets/logo/451081.png'),
        451082: require('@/assets/logo/451082.png')
      },
      bannerList: [
        require('@/assets/images/index/banner1.jpg'),
        require('@/assets/images/index/banner2.jpg'),
        require('@/assets/images/index/banner3.jpg')
      ],
      showLogo: '',
      search: '',
      imgSrc: '',
      titleText: '',
      logoDefault: false,
      logoChange: false,
      showMenu: false,
      dialogVisible: false,
      pathList: [],
      logoText: '',
      perCenterMenu: personalCenterMenu
    };
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo',
      'getTenantParams',
      'showAreaCode'
    ]),
    title: function () {
      return AreaCodeHolder.getInstance().areaName;
    }
  },
  watch: {
    showAreaCode: {
      handler (val) {
        this.setLogo(val);
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.setLogo(4510);
    this.logoText = this.getTenantParams.title;
    this.getCityName();
    document.title = this.title + '农村数字普惠金融服务平台';
  },
  methods: {
    setLogo (code) {
      if (code) {
        // this.showLogo = this.logoMap[code] || this.logoMap[4510];
        this.showLogo = require('./logo.png');
      }
    },
    isShowSigninAction () {
      if (!this.userInfo || !this.userInfo.username) {
        this.dialogVisible = true;
      } else {
        this.showMenu = true;
      }
    },
    toPath (item) {
      if (item.path) {
        this.$router.push(item.path);
      } else if (!item.path && item.name === '退出登录') {
        this.$confirm('确定要退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('SET_USER_INFO', {});
          window.localStorage.clear();
          this.$router.push('/index');
        }).catch();
      }
    },
    changeSkin,
    publishProject () {
      if (this.isSignin) {
        // 交易方式 1公开交易 2协议交易
        this.$store.commit('SET_TRADE_TYPE', 1);
        window.open(window.location.origin + '/#/publish-project/publisher-info');
      } else {
        this.$router.push('/signin');
      }
    },
    publishPurchase () {
      if (this.isSignin) {
        window.open(window.location.origin + '/#/publish-purchase/publisher-info');
      } else {
        this.$router.push('/signin');
      }
    },
    goHomepage () {
      this.$router.push('/index');
    },
    getCityName () {
      // let quan ='http://yongjixian.jlncjy.cn/';
      // portal-tiandong.cacfintech.com
      // changchunshi.jlncjy.com
      // jlncjy.com
      // jlncjy.cn
      let origin = window.location.origin;
      let domainName;
      if (origin.split('//')[1].split('.')[0] === 'www') {
        domainName = origin.split('//')[1].split('.')[1];
      } else {
        domainName = origin.split('//')[1].split('.')[0];
        if (domainName.includes('localhost')) {
          domainName = 'localhost';
        }
      }
      Service.selectSiteInfoByDomain(domainName).then(res => {
        if (res && res.code === '0') {
          this.titleText = res.data.domainName;
          this.pathList = res.data.pathList;
          localStorage.setItem('level', res.data.level || '');
          localStorage.setItem('areaCode', res.data.areaCode || '');
          if (res.data.domainName) {
            this.logoChange = true;
          } else {
            this.logoDefault = true;
          }
          if (res.data.pathList) {
            localStorage.setItem('pathList', JSON.stringify(this.pathList));
          } else {
            localStorage.setItem('pathList', []);
          }
        }
      }).catch(() => { });
    }
  }
};
